module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_Passwords.da23c8de.svg";